import './ContactData.scss'
import ContactData from './ContactData'

export default ContactData